import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const modules = {
    toolbar: [
        [{ size: [] }],
        [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
        ],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        ["link"],
        ["blockquote", "strike", "underline", "italic", "bold"],
    ]
}

function TextContent() {
    const [value, setValue] = useState('')
    return (
        <div className="flex flex-row-reverse mb-4 h-3/5">
            <p className="w-28 text-right"> :متن</p>
            <div className='h200 border border-slate-300 rounded'>
                <ReactQuill
                    theme="snow"
                    value={value}
                    onChange={setValue}
                    modules={modules}
                />
            </div>
        </div>
    )
}
export default TextContent;